import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insideImages } from '../data/insideImages';
import { Ornament } from './Ornament';
import { ProductName } from './ProductName';
export function InsideCarousel() {
  const [[index, direction], setState] = useState<[number, number]>([0, 0]);
  const total = insideImages.length;
  const go = (step: number) => {
    setState(([current]) => [(current + step + total) % total, step]);
  };
  const image = insideImages[index];
  const navClasses = 'absolute top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-gold bg-cream text-burgundy shadow-soft transition-colors duration-150 hover:bg-beige focus:outline-none focus-visible:ring-2 focus-visible:ring-burgundy';
  return <section className="border-y border-gold/20 bg-white px-4 py-20 sm:py-28" data-id="element-168" data-mp="2yjano200ysg0">
      <div className="mx-auto max-w-5xl" data-id="element-169" data-mp="2to577ipe65zb">
        <div className="text-center" data-id="element-170" data-mp="2mtaeokfisy6t">
          <h2 className="mx-auto max-w-3xl text-3xl font-semibold uppercase leading-tight tracking-wide text-ink sm:text-4xl" data-id="element-171" data-mp="2mubzvhq93129">
            See inside <ProductName data-id="element-172" data-mp="2rtyd3r62whb2" />
          </h2>
          <Ornament className="mt-5" data-id="element-173" data-mp="2wqyis0z0ni1n" />
          <p className="mt-4 text-base text-ink-muted" data-id="element-174" data-mp="2wpwxl3oadf67">
            Real pages from the 100% visual teaching system.
          </p>
        </div>

        <div className="relative mx-auto mt-12 max-w-xl" role="region" aria-roledescription="carousel" aria-label="Inside pages of the system" data-id="element-175" data-mp="35sejfh0145so">
          <div className="relative overflow-hidden rounded-2xl border border-gold/30 bg-white p-3 shadow-luxe" data-id="element-176" data-mp="3fhy5swmyahsa">
            <div className="relative aspect-[4/5] overflow-hidden rounded-xl bg-mist" data-id="element-177" data-mp="3kh2c9fihq1ex">
              <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-178" data-mp="3oiwa7g1awrbe">
                <motion.img key={image.src} src={image.src} alt={image.alt} custom={direction} initial={{
                opacity: 0,
                x: direction >= 0 ? 40 : -40
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction >= 0 ? -40 : 40
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} drag="x" dragConstraints={{
                left: 0,
                right: 0
              }} dragElastic={0.2} onDragEnd={(_, info) => {
                if (info.offset.x < -60) go(1);
                if (info.offset.x > 60) go(-1);
              }} className="absolute inset-0 h-full w-full cursor-grab object-contain active:cursor-grabbing" draggable={false} data-id="element-179" data-mp="3thh1gpyks0np" />
              </AnimatePresence>
            </div>
          </div>

          <button type="button" onClick={() => go(-1)} aria-label="Previous image" className={`${navClasses} left-0 -translate-x-1/2 sm:-translate-x-[130%]`} data-id="element-180" data-mp="rqnj39k5ghy9">
            <ChevronLeftIcon size={20} aria-hidden="true" data-id="element-181" data-mp="2yewe963p8zzm" />
          </button>
          <button type="button" onClick={() => go(1)} aria-label="Next image" className={`${navClasses} right-0 translate-x-1/2 sm:translate-x-[130%]`} data-id="element-182" data-mp="33bwev1hs5ajc">
            <ChevronRightIcon size={20} aria-hidden="true" data-id="element-183" data-mp="2tll8l8amip9a" />
          </button>

          <div className="mt-6 flex justify-center gap-2" data-id="element-184" data-mp="2fmvb3rjw6nke">
            {insideImages.map((item, dotIndex) => <button key={item.src} type="button" onClick={() => setState([dotIndex, dotIndex > index ? 1 : -1])} aria-label={`Show image ${dotIndex + 1}`} aria-current={dotIndex === index} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-burgundy ${dotIndex === index ? 'w-7 bg-wine' : 'w-2.5 bg-gold/40 hover:bg-gold'}`} data-id="element-185" data-mp="2koatfbuoqfz3" data-mpi={dotIndex} />)}
          </div>
        </div>
      </div>
    </section>;
}